"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EddMeasuresRef = void 0;
const Field_type_1 = require("../../types/Field.type");
exports.EddMeasuresRef = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.edd_measures.label',
    fallbackLabel: 'EDD measures',
    type: Field_type_1.FieldType.Enum,
    options: [
        { key: 'ADDITIONAL_DOCUMENTATION_COLLECTION', label: 'fields.enm.edd_measures.options.ADDITIONAL_DOCUMENTATION_COLLECTION', fallbackLabel: 'Additional documentation collection' },
        { key: 'SOW_SOF_COLLECTION_VERIFICATION', label: 'fields.enm.edd_measures.options.SOW_SOF_COLLECTION_VERIFICATION', fallbackLabel: 'SoW/SoF collection/verification' },
        { key: 'FACE_TO_FACE_VERIFICATION_ON_SITE_VISIT', label: 'fields.enm.edd_measures.options.FACE_TO_FACE_VERIFICATION_ON_SITE_VISIT', fallbackLabel: 'Face-to-face verification/on-site visit' },
        { key: 'ADVERSE_MEDIA_SCREENING', label: 'fields.enm.edd_measures.options.ADVERSE_MEDIA_SCREENING', fallbackLabel: 'Adverse media screening' },
        { key: 'OTHER', label: 'fields.enm.edd_measures.options.OTHER', fallbackLabel: 'Other' },
    ],
    trackFieldValueWithAnalytics: false,
};
